import { motion } from "framer-motion";

const journey = [
  { city: "Manchester", note: "Lets & sales — learning the ground floor of property." },
  { city: "London", note: "Full developments from scratch under a mentor's wing." },
  { city: "Warwickshire", note: "Home turf — bringing every standard with me." },
];

export default function AboutMe() {
  return (
    <section id="about-me" className="py-24 sm:py-32 bg-[#0B1215] text-[#F8F9FA] grain relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="font-mono-label text-[#FF5A36] mb-4">· ABOUT ME</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
              The story behind <span className="italic font-light">the standards</span>.
            </h2>

            <div className="mt-12 space-y-8">
              {journey.map((j, i) => (
                <motion.div
                  key={j.city}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                  className="border-l-2 border-[#FF5A36] pl-5"
                >
                  <div className="font-mono-label text-[#F8F9FA]/50">0{i + 1} ·</div>
                  <div className="font-display text-2xl tracking-tight mt-1">{j.city}</div>
                  <div className="text-sm text-[#F8F9FA]/70 mt-1">{j.note}</div>
                </motion.div>
              ))}
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-7"
          >
            <div className="border-2 border-[#F8F9FA]/15 p-8 sm:p-10 lg:p-12 space-y-6 text-[#F8F9FA]/85 leading-relaxed text-base sm:text-lg">
              <p>
                I first got into property the long way round — starting on the agency floor doing
                <span className="text-[#F8F9FA]"> lets and sales</span>. It taught me how a property
                actually <em className="not-italic text-[#FF5A36]">moves</em>, what makes a tenant
                stay, and what makes a buyer walk.
              </p>
              <p>
                From there I progressed into full developments, taking properties from
                <span className="text-[#F8F9FA]"> empty shells to finished homes</span> under the
                wing of a seasoned property developer who took me on early in my career. He showed
                me what it looks like to do the work properly, end-to-end, and that lesson has
                stuck.
              </p>
              <p>
                Over the years I've worked across <span className="text-[#F8F9FA]">Manchester,
                London</span> and have now settled back on my <span className="text-[#F8F9FA]">home
                turf in Warwickshire</span> — bringing every standard, every habit and every hard
                lesson with me.
              </p>
              <p className="pt-4 border-t border-[#F8F9FA]/10">
                <span className="font-display text-2xl text-[#F8F9FA] block mb-2 tracking-tight">
                  Meticulous about high standards.
                </span>
                If a job is worth doing, it's worth handing back better than it was promised. That's
                the whole reason The Property Curator exists.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
